
import { useState } from 'react';

interface QuickAccessSectionProps {
  onCategorySelect: (category: string) => void;
}

const QuickAccessSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Quick Access Tools</h2>
          <p className="text-xl text-gray-600">
            Essential resources for mortgage professionals
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-search-line text-blue-600 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Search Guidelines</h3>
            <p className="text-gray-600 text-sm">
              Find specific loan guidelines quickly with our advanced search
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-bookmark-line text-green-600 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Saved Guidelines</h3>
            <p className="text-gray-600 text-sm">
              Access your bookmarked guidelines for quick reference
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-notification-line text-purple-600 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Updates</h3>
            <p className="text-gray-600 text-sm">
              Stay informed about the latest guideline changes
            </p>
          </div>
          
          <a href="/assessor-directory" className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer border-2 border-orange-200 hover:border-orange-300">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-government-line text-orange-600 text-xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">AssessorLink</h3>
            <p className="text-gray-600 text-sm">
              Find county assessors and FEMA flood data by address
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default QuickAccessSection;
